import { useState, useEffect } from "react";
import "./FormContentPhone.css";
import { Question, UpdateQuestionPayload } from "effno-core";
import { apiUpdateQuestion } from "../../services/QuestionService";
import { toastFail, toastSuccess } from "../../config";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { selectEditingForm, selectUIStates, setEditingForm } from "../../redux/features/appData";
import { useDispatch } from "react-redux";
import { PHONE_SETTINGS } from "../config/questionSettings";
import { DEBOUNCE_TIME } from "../config/forms";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { apiFormHasEdits } from "../../services/FormService";
import { getCountryCallingCode } from "react-phone-number-input";

type FormContentPhoneProps = {
    question: Question;
    allowSaving?: boolean;
}

export const FormContentPhone = ({question, allowSaving = true} : FormContentPhoneProps) => {

    const dispatch = useDispatch();

    const editingForm = useSelector(selectEditingForm);
    const uiStates = useSelector(selectUIStates);

    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [phone, setPhone] = useState<string>("");

    const [debouncedData, setDebouncedData] = useState<any | undefined>(undefined);
    const [debounceSettings, setDebounceSettings] = useState<any | undefined>(undefined);


    useEffect(() => {
        setTitle(question.title);
        setDescription(question.description);
    }, [question]);

    // Debounce settings changes
    useEffect(() => {
        const handler = setTimeout(() => {
            if (!debounceSettings) {
                return;
            }
            setDebouncedData(debounceSettings);
        }, DEBOUNCE_TIME);

        // Clear the timeout if settings changes (i.e., user is still typing)
        return () => {
            clearTimeout(handler);
        };
    }, [debounceSettings]);

    // Effect to save the debounced data whenever it changes
    useEffect(() => {
        (async () => {
            if (!debouncedData) {
                return;
            }

            console.log("debouncedData: ", debouncedData);
            
            await handleSave();
        })()
    }, [debouncedData]);

    useEffect(() => {
        setDebounceSettings({
            title,
            description,
            phone,
        })
    }, [title, description, phone])

    const updateRedux = () => {
        if (!editingForm) {
            return;
        }

        const index = editingForm.questions.findIndex((q: Question) =>  q.id === question.id);

        if (index === -1) {
            toast("Can't find question id", toastFail);
            return;
        }

        const newQuestions = [...editingForm.questions];
        newQuestions[index] = {
            ...question,
            title,
            description
        };

        dispatch(setEditingForm({...editingForm, hasEdits: true, questions: newQuestions}));
    }

    const handleSave = async () => {
        if (!editingForm || !allowSaving) {
            return;
        }

        // update question in redux first to avoid delay lag causing issues
        updateRedux();

        const settings = question.settings ? JSON.parse(question.settings) : PHONE_SETTINGS;

        const payload : UpdateQuestionPayload = {
            questionId: question.id,
            type: question.type,
            title: title,
            description: description,
            required: question.required,
            settings: JSON.stringify(settings),  // these don't change in this instance
            conditions: question.conditions
        }

        const newQuestion = await apiUpdateQuestion(payload);

        if (!newQuestion) {
            toast("Error saving update", toastFail);
            return;
        }

        await apiFormHasEdits(editingForm.id);
        console.log("Question updated");

        // update redux
        // const index = editingForm.questions.findIndex((q: Question) =>  q.id === question.id);

        // if (index === -1) {
        //     toast("Can't find question id", toastFail);
        //     return;
        // }

        // const newQuestions = [...editingForm.questions];
        // newQuestions[index] = newQuestion;

        // await apiFormHasEdits(editingForm.id);

        // dispatch(setEditingForm({...editingForm, hasEdits: true, questions: newQuestions}));

        // console.log("Question updated");

    }

    const settings = question.settings ? JSON.parse(question.settings) : PHONE_SETTINGS;
    const defaultCountryCode = (settings.defaultCountryCode || "us").toLowerCase();
    const defaultPhoneAsCode = getCountryCallingCode((defaultCountryCode as string).toUpperCase() as any);

    console.log("[FormContentPhone] defaultCountryCode: ", defaultCountryCode);
    console.log("[FormContentPhone] code: ", defaultPhoneAsCode);

    return (
        <div className="form-content-body">
            <div className="form-content-title">
                <input 
                    type="text"
                    placeholder="..."
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    data-testid="question-title"
                />
                {/* {question.required && <span>*</span>} */}
            </div>
            <div className="form-content-description">
                <input 
                    type="text"
                    placeholder="Description (optional)"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    data-testid="question-description"
                />
            </div>   

            <div 
                // style={{paddingLeft: "8px"}}
                className="form-content-phone"
            >
                <PhoneInput
                    country={defaultCountryCode}
                    disableCountryGuess={false}
                    value={phone || defaultPhoneAsCode}
                    enableSearch={true}
                    onChange={phone => setPhone(phone)}
                    disabled={true}
                    inputStyle={{
                        // backgroundColor: "var(--ftAnswerBackgroundColor)",
                        backgroundColor: "transparent",
                        width: "250px",
                        color: "var(--ftAnswerColor)",
                        border: "1px solid var(--ftAnswerColor)",
                        fontSize: "1.25rem"
                    }}
                    dropdownStyle={{
                        backgroundColor: "transparent",
                        border: "1px solid var(--ftAnswerColor)"
                    }}
                    buttonStyle={{
                        backgroundColor: "transparent",
                        border: "1px solid var(--ftAnswerColor)"
                    }}
                    inputClass="form-content-phone-input"
                    // inputStyle={{
                    //     backgroundColor: "var(--ftAnswerBackgroundColor)",
                    //     width: "250px",
                    //     color: "var(--ftAnswerColor)",
                    // }}
                    // dropdownStyle={{backgroundColor: "var(--ftAnswerBackgroundColor)"}}
                    // buttonStyle={{backgroundColor: "var(--ftAnswerBackgroundColor)"}}
                    
                />
            </div>    

            {/* <button 
                onClick={handleSave}
                data-testid="save-question"
            >
                temp save button before debounce 
            </button> */}
        </div>
    )
}